import { render, staticRenderFns } from "./Congratulations.vue?vue&type=template&id=4b84fbf9&scoped=true"
import script from "./Congratulations.vue?vue&type=script&lang=js"
export * from "./Congratulations.vue?vue&type=script&lang=js"
import style0 from "./Congratulations.vue?vue&type=style&index=0&id=4b84fbf9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b84fbf9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
